import { Button, Modal, message } from "antd";
import React from "react";
import { AiOutlineGlobal } from "react-icons/ai";
import { RiLinkM } from "react-icons/ri";
import { useIntl } from "react-intl";
import { catalogSVG, copySVG } from "../../../assets/SVGs/SVGs";
import { location } from "../../../types/calendar";
import CatalogModalWrapper from "./modal-wrappers/CatalogModalWrapper";
import DirectLinksSkeleton from "./modal-wrappers/DirectLinksSkeleton";

type catalogProps = {
  locationLinksData: location;
  isLoading: boolean;
  handleRemoveLink: (params: any) => Promise<void>;
  handleCreateLink: (params: any) => Promise<void>;
  catalogModal: boolean;
  setCatalogModal: React.Dispatch<React.SetStateAction<boolean>>;
};
export default function CatalogDirectLink({
  locationLinksData,
  handleCreateLink,
  handleRemoveLink,
  isLoading,
  catalogModal,
  setCatalogModal,
}: catalogProps) {
  const intl = useIntl();
  const domain = window.location.origin;
  // if (isLoading) {
  //   return (
  //     <div className="px-6 py-8 space-y-6 bg-white rounded">
  //       <DirectLinksSkeleton />
  //     </div>
  //   );
  // }
  return (
    <div className="px-6 py-8 space-y-6 bg-white rounded">
      <div>
        {locationLinksData?.have_catalog_link ? (
          <div className="text-[#479821] flex justify-end gap-1 items-center h-7">
            <span className="">{<AiOutlineGlobal color="#479821" />}</span>
            <span className="self-start">
              {intl.formatMessage({ id: "activated_link" })}
            </span>
          </div>
        ) : null}
      </div>
      <div className="flex flex-col items-center space-y-2">
        <div>{catalogSVG}</div>
        <div>
          {locationLinksData?.have_catalog_link ? (
            <div className="space-y-3">
              <p className="font-semibold text-center text-color-primary">
                {intl.formatMessage({ id: "catalog_link" })}
              </p>
              <div className="flex justify-between gap-2 bg-[#EEF0FF] p-1 rounded items-center">
                <Button
                  type="link"
                  htmlType="button"
                  onClick={() => {
                    navigator.clipboard.writeText(
                      domain + "/" + locationLinksData?.slug
                    );
                    message.success(intl.formatMessage({ id: "copy_link" }));
                  }}
                >
                  {copySVG}
                </Button>
                <p className="px-2 flex items-center gap-2 h-7 max-w-[150px]  xl:max-w-[200px] ">
                  <span className="overflow-hidden text-color-primary text-ellipsis whitespace-nowrap">
                    {domain + "/" + locationLinksData?.slug}
                  </span>
                  <RiLinkM size={18} color="#479821" />
                </p>
              </div>
              <p className="text-center text-color-sec-title">
                {intl.formatMessage({ id: "click_to_copy_link" })}
              </p>
            </div>
          ) : (
            <div className="space-y-3 text-center">
              <p className="font-semibold text-color-primary">
                {intl.formatMessage({ id: "create_catalog_link" })}
              </p>
              <p className="text-color-sec-title">
                {intl.formatMessage({ id: "create_link_for_all_services" })}
              </p>
            </div>
          )}
        </div>
      </div>
      <div>
        {locationLinksData?.have_catalog_link ? (
          <Button
            type="primary"
            htmlType="button"
            block
            danger
            icon={<RiLinkM size={18} color="white" />}
            loading={isLoading}
            onClick={() => {
              handleRemoveLink({ link_type: "catalog_link", value: 0 });
            }}
          >
            <span className="text-white">
              {intl.formatMessage({ id: "delete_link" })}
            </span>{" "}
          </Button>
        ) : (
          <Button
            type="primary"
            htmlType="button"
            block
            className=""
            onClick={() => {
              handleCreateLink({ link_type: "catalog_link", value: 1 });
            }}
            icon={<RiLinkM size={18} />}
            loading={isLoading}
          >
            <span className="text-white">
              {intl.formatMessage({ id: "create_link" })}
            </span>{" "}
          </Button>
        )}
      </div>
      <div>
        <Modal
          className="md:min-w-[550px]"
          maskClosable={false}
          open={catalogModal}
          onCancel={() => setCatalogModal(false)}
          destroyOnClose
          footer={null}
        >
          <CatalogModalWrapper
            isLoading={isLoading}
            have_catalog_link={locationLinksData?.have_catalog_link}
            catalogModal={catalogModal}
            catalogLink={locationLinksData?.slug}
            handleCreateLink={handleCreateLink}
            handleRemoveLink={handleRemoveLink}
          />
        </Modal>
      </div>
    </div>
  );
}
